"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * Composite Release-ReleasePart key - designed to be used as identifier of release part within a release.
 *
 * @author Jan Prokop
 */


var ReleasePartKey =
/*#__PURE__*/
function () {
  function ReleasePartKey(releaseId, productCategoryId) {
    _classCallCheck(this, ReleasePartKey);

    this.releaseId = releaseId;
    this.productCategoryId = productCategoryId;
  }

  _createClass(ReleasePartKey, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ReleasePartKey) {
        return this.releaseId === other.releaseId && this.productCategoryId === other.productCategoryId;
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.releaseId + '-' + this.productCategoryId);
    }
  }]);

  return ReleasePartKey;
}();

exports.ReleasePartKey = ReleasePartKey;